import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Layout from "../components/layout/Layout";
import EvaluationComp from "../components/EvaluationComp";
import EvaluationResult from "../components/EvaluationResult";

const Evaluation = () => {
  let { path } = useRouteMatch();
  return (
    <>
    <Switch>
      <Route exact path={`${path}/lung`}>
        <Layout>
          <EvaluationComp cancer={"lung"}/>
        </Layout>
      </Route>
      <Route exact path={`${path}/prostate`}>
        <Layout>
          <EvaluationComp cancer={"prostate"}/>
        </Layout>
      </Route>
      <Route exact path={`${path}/breast`}>
        <Layout>
          <EvaluationComp cancer={"breast"}/>
        </Layout>
      </Route>
      <Route exact path={`${path}/result`}>
        <Layout>
          <EvaluationResult />
        </Layout>
      </Route>
    </Switch>
      
    </>
  );
};

export default Evaluation;
